<template>
  <div :class="isCollapse ? 'menu width70' : 'menu'">
    <div class="logobox">
      <img
        v-show="!isCollapse"
        class="bigImg"
        :src="require('img/menu/logoText.png')"
      />
      <img
        v-show="isCollapse"
        class="smallImg"
        :src="require('img/menu/logo.png')"
      />
    </div>
    <ul class="menuUl">
      <li
        :class="active === 0 ? 'active menu-item' : 'menu-item'"
        @click="to('index', 0)"
        title="自助打印"
      >
        <i :class="active === 0 ? 'activePrintImg' : 'printImg'" alt="" /><span
          v-show="!isCollapse"
          class="label"
          >自助打印</span
        >
      </li>
      <li
        :class="active === 1 ? 'active menu-item' : 'menu-item'"
        @click="to('device', 1)"
        title="设备管理"
      >
        <i
          :class="active === 1 ? 'activeDeviceImg' : 'deviceImg'"
          alt=""
        /><span v-show="!isCollapse" class="label">设备管理</span>
      </li>
      <li
        :class="active === 2 ? 'active menu-item' : 'menu-item'"
        @click="to('myShare', 2)"
        title="我的分享"
      >
        <i :class="active === 2 ? 'activeShareImg' : 'shareImg'" alt="" /><span
          v-show="!isCollapse"
          class="label"
          >我的分享</span
        >
      </li>
      <li
        :class="active === 3 ? 'active menu-item' : 'menu-item'"
        @click="to('record', 3)"
        title="打印记录"
      >
        <i
          :class="active === 3 ? 'activeRecordImg' : 'recordImg'"
          alt=""
        /><span v-show="!isCollapse" class="label">打印记录</span>
      </li>
    </ul>
    <div class="switch">
      <i :class="isCollapse ? 'flag rotate180' : 'flag'" @click="open"></i>
    </div>
  </div>
</template>

<script>
import { signIn } from "utils/utils";
import { mapState } from "vuex";

export default {
  data() {
    return {
      active: 0,
      isCollapse: false
    };
  },
  computed: {
    ...mapState("user", ["userInfo"])
  },
  created() {
    switch (this.$route.name) {
      case "index":
        this.active = 0;
        break;
      case "device":
        this.active = 1;
        break;
      case "myShare":
        this.active = 2;
        break;
      case "record":
        this.active = 3;
        break;
      default:
        break;
    }
  },
  methods: {
    to(name, active) {
      if (active === this.active) return;
      if (!this.userInfo) return signIn();
      this.$router.push({ name });
      this.active = active;
    },
    open() {
      this.isCollapse = !this.isCollapse;
    }
  },
  watch: {
    $route(n, o) {
      switch (n.name) {
        case "index":
          this.active = 0;
          break;
        case "device":
          this.active = 1;
          break;
        case "myShare":
          this.active = 2;
          break;
        case "record":
          this.active = 3;
          break;
        default:
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.logobox {
  height: 90px;
  width: 100%;
  position: relative;
  .bigImg {
    position: absolute;
    width: 114px;
    top: 18px;
    left: 19px;
  }
  .smallImg {
    position: absolute;
    width: 32px;
    top: 18px;
    left: 19px;
  }
}

.menu {
  position: relative;
}

.menuUl {
  max-height: calc(100vh - 90px - 57px);
  overflow-y: auto;
  position: relative;
  /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
  &::-webkit-scrollbar {
    width: 7px;
    height: 7px;
    background-color: #f6f7fc;
  }

  /*定义滚动条轨道 内阴影+圆角*/
  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #f6f7fc;
  }

  /*定义滑块 内阴影+圆角*/
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: rgba(144, 147, 153, 0.5);
    &:hover {
      cursor: pointer;
      background-color: rgba(144, 147, 153, 0.7);
    }
  }
}

.width70 {
  width: 70px !important;
}

.menu-item {
  display: flex;
  height: 65px;
  align-items: center;
  cursor: pointer;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  padding-left: 25px;
  i {
    display: block;
    width: 20px;
    height: 20px;
  }
  &:hover {
    background-color: rgba($theme-color, 0.1);
    .label {
      color: $theme-color !important;
    }
    .printImg {
      background-image: url("~@/assets/img/menu/print_.png");
    }
    .deviceImg {
      background-image: url("~@/assets/img/menu/device_.png");
    }
    .recordImg {
      background-image: url("~@/assets/img/menu/record_.png");
    }
    .shareImg {
      background-image: url("~@/assets/img/menu/share_.png");
    }
  }
  img {
    width: 20px;
    height: 20px;
    margin-left: 25px;
  }
  span {
    margin-left: 11px;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #717598;
    width: 80px;
    flex-shrink: 0;
  }
}

.active {
  background-color: rgba($theme-color, 0.1);
  .label {
    color: $theme-color !important;
  }
}

.switch {
  height: 57px;
  border-top: 1px solid #e0e0e0;
  width: 100%;
  box-sizing: border-box;
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  .rotate180 {
    transform: rotate(180deg);
  }
  .flag {
    transition: all 0.3s;
  }
  i {
    display: block;
    background: url("~@/assets/img/menu/switchIcon.png") no-repeat center;
    width: 20px;
    height: 17px;
    &:hover {
      background: url("~@/assets/img/menu/switchIcon_h.png") no-repeat center;
    }
  }
}

.printImg {
  background-image: url("~@/assets/img/menu/print.png");
}

.activePrintImg {
  background-image: url("~@/assets/img/menu/print_.png");
}

.deviceImg {
  background-image: url("~@/assets/img/menu/device.png");
}

.activeDeviceImg {
  background-image: url("~@/assets/img/menu/device_.png");
}

.recordImg {
  background-image: url("~@/assets/img/menu/record.png");
}

.activeRecordImg {
  background-image: url("~@/assets/img/menu/record_.png");
}

.shareImg {
  background-image: url("~@/assets/img/menu/share.png");
}

.activeShareImg {
  background-image: url("~@/assets/img/menu/share_.png");
}
</style>
